export default {
  data () {
    return {
      filter: {
        selected: {},
        badges: []
      },
      filterBadges: []
    }
  },

  methods: {
    updateFilters (filters) {
      this.filter.selected = filters
    },

    submitFilters () {
      this.updateFilterBadges()
      this.search()
      this.slideFiltersPan()
    },

    resetFilters (slidePan = false, search = true) {
      // reinit children filters
      this.$refs.filters.resetAll()
      // reinit badges
      this.filterBadges = []
      // reinit component filters
      this.updateFilters({})

      if (slidePan === true) this.slideFiltersPan()

      if (search) this.search()
    },

    updateFilterBadges () {
      let ret = []

      if (!this.filter.selected) {
        this.filterBadges = ret
        return
      }

      for (let [key, filter] of Object.entries(this.filter.selected)) {
        switch (key) {
          case 'category':
            if (filter !== 0) { ret.push(`min ${'*'.repeat(filter)}`) }
            break
          case 'price':
            if (filter.min !== filter.max) {
              // si les filtres de prix sont égaux aux bornes, inutile de les afficher
              // On utilise math.floor et math.ceil car les valeurs min et max sont arrondies (cf. filtre price.vue)
              if (filter.min !== Math.floor(this.origPrices.min)) {
                ret.push(`min ${this.$options.filters.currency(filter.min)}`)
              }
              if (filter.max !== Math.ceil(this.origPrices.max)) {
                ret.push(`max ${this.$options.filters.currency(filter.max)}`)
              }
            } else {
              ret.push(`${this.$options.filters.currency(filter.min)}`)
            }
            break
          case 'services':
          default:
            for (let item of filter) {
              ret.push(item.text)
            }
            break
        }
      }

      this.filterBadges = ret
    }
  }
}
